import { render, staticRenderFns } from "./EstimatesOldPanelsLocalSpecs.vue?vue&type=template&id=241a9341&"
import script from "./EstimatesOldPanelsLocalSpecs.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPanelsLocalSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports